<template>
  <AppBannerExtended @close="dismissAlertsBanner">
    <template #overline>
      <div class="cfb-AlertsBanner">
        <AppBadge :content="$t('dashboard.new')" class="cfb-AlertsBanner_Tag" inline is-uppercase />
        <div class="cfb-AlertsBanner_Message">
          {{ $t('alerts.banner.content') }}

          <AppHrefLink
            class="cfb-MessageLink"
            href="https://oboard.atlassian.net/wiki/spaces/OBPFJ/pages/2239037442"
          >
            {{ $t('action.learn_more') }}
          </AppHrefLink>
        </div>
      </div>
    </template>
    <template #header-actions>
      <AppButtonNext
        :size="BUTTON_SIZES_NEXT.SM"
        :variant="BUTTON_VARIANTS.SECONDARY"
        icon-after="notifications"
        @click="goToAlerts"
      >
        {{ $t('alerts.banner.button') }}
      </AppButtonNext>
    </template>
  </AppBannerExtended>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

import { useSettingsBackButton } from '@/composables/settings-back-button'
import { ROUTE_NAMES } from '@/routes/route-helpers'
import { BUTTON_SIZES_NEXT, BUTTON_VARIANTS } from '@/utils/components-configurations/app-button'
import { IS_SHOW_BANNER_ON_FEED, USER_SETTINGS_MAPPER } from '@/utils/user-settings'

import AppBannerExtended from '@/components/AppBannerExtended'
import AppHrefLink from '@/components/AppHrefLink'
import AppBadge from '@/components/ui/AppBadge/AppBadge'
import AppButtonNext from '@/components/ui/AppButtonNext/AppButtonNext'

defineOptions({
  name: 'CheckinsFeedBanner'
})

const store = useStore()
const router = useRouter()

const { saveSettingsReferer } = useSettingsBackButton()

const goToAlerts = () => {
  saveSettingsReferer()
  router.push({ name: ROUTE_NAMES.SETTINGS_AUTOMATIONS })
}

const dismissAlertsBanner = async () => {
  await store.dispatch('system/updateUserSettings', {
    [USER_SETTINGS_MAPPER[IS_SHOW_BANNER_ON_FEED]]: false
  })
}
</script>

<style lang="scss" scoped>
.cfb-AlertsBanner_Tag {
  --color: #{rgba($white, 0.2)};
  --badge-size: 18px;
  --padding: 0px 6px;
  --badge-border-radius: #{$border-radius-sm};
}

.cfb-AlertsBanner_Message {
  color: $white;
  font-size: $fs-12;
  line-height: 18px;
}

.cfb-MessageLink {
  color: inherit;
  text-decoration: underline;
}

.cfb-AlertsBanner {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>
